import { InfoIcon, InfoIconTransparent, WarningIcon } from "$components/icons";
import { alpha, makeStyles } from "@material-ui/core";
import { Alert, type AlertProps, AlertTitle } from "@material-ui/lab";
import classnames from "classnames";
import type { ReactNode } from "react";

const useStyles = makeStyles((theme) => ({
  container: {
    color: theme.palette.text.primary,
    maxHeight: "59px",
    padding: "0px 12px",
    display: "flex",
    alignItems: "center",
    "& .MuiAlert-message": {
      width: "100%",
    },
  },
  multiline: {
    maxHeight: "none",
    alignItems: "flex-start",
    padding: "8px 12px",
  },
  title: {
    fontWeight: 700,
  },
  infoBackground: {
    backgroundColor: alpha(theme.palette.brand.main, 0.15),
  },
  infoIcon: {
    color: theme.palette.primary.main,
  },
  strongInfoBackground: {
    backgroundColor: theme.palette.primary.main,
  },
  strongInfoIcon: {
    color: "#FFB81C",
  },
  strongInfoText: {
    color: theme.palette.primary.contrastText,
  },
  errorBackground: {
    backgroundColor: alpha(theme.palette.error.main, 0.2),
  },
  errorIcon: {
    color: theme.palette.error.main,
  },
  warningBackground: {
    backgroundColor: alpha(theme.palette.warning.main, 0.2),
  },
  warningIcon: {
    color: theme.palette.warning.main,
  },
}));

export const Callout: FCwC<
  {
    type?: "info" | "error" | "warning" | "strongInfo";
    /** Bold first line; providing it also lifts the single-line height cap. */
    title?: ReactNode;
  } & Omit<AlertProps, "title">
> = ({ type = "info", title, children, className, ...props }) => {
  const styles = useStyles();

  return (
    <Alert
      {...props}
      className={classnames(
        styles.container,
        title != null && styles.multiline,
        styles[`${type}Background`],
        type === "strongInfo" && styles.strongInfoText,
        className,
      )}
      icon={
        type === "strongInfo" ? (
          <InfoIconTransparent
            viewBox="0 0 32 32"
            fontSize="large"
            htmlColor="#FFB81C"
          />
        ) : type === "info" ? (
          <InfoIcon
            viewBox="0 0 32 32"
            fontSize="large"
            className={styles[`${type}Icon`]}
          />
        ) : (
          <WarningIcon
            viewBox="0 0 32 32"
            htmlColor="black"
            fontSize="large"
            className={styles[`${type}Icon`]}
          />
        )
      }
    >
      {title != null && (
        <AlertTitle className={styles.title}>{title}</AlertTitle>
      )}
      {children}
    </Alert>
  );
};
